const inventorySetupStyles = (theme) => ({
  container: {
    padding: { xs: "0px 20px", sm: 0 },
  },
  headSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
  },
  searchBox: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      width: { xs: "100%", sm: "343px" },
      height: "48px",
      backgroundColor: theme.palette.customColor?.white || "#FFFFFF",
      outline: "none !important",
      borderRadius: 0,
      fontFamily: "Lexend",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "100%",
    },
  },
  addBtn: {
    height: "40px",
    px: "20px",
    py: "11px",
    fontSize: "16px",
    textTransform: "none",
    borderRadius: "0px",
    display: { xs: "none", sm: "inline-flex" },
  },
  mobileBtns: {
    display: { xs: "flex", sm: "none" },
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  mobileAddBtn: {
    width: "auto",
    padding: "10px",
    fontSize: "16px",
    textTransform: "none",
    borderRadius: "0px",
  },
  tableContainer: {
    // Add any specific table container styles if needed
  },
});

export default inventorySetupStyles;

